import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-cart-layout',
  templateUrl: './cart-layout.component.html',
  styleUrls: ['./cart-layout.component.scss'],
})
export class CartLayoutComponent implements OnInit, OnChanges {
  totalAmountOfItems = 0;
  @Input() cart: any;
  subscription: Subscription;
  public verify = false;
  reloadPage: any;
  plan: string;
  packages: any;
  emailId: String;
  user: any;

  @Output() reloadCart: EventEmitter<any> = new EventEmitter();



  constructor(
    private router: Router,
    private transactionService: TansactionService,
    private localStorageService: LocalStorageService,
    private loginSignupService: LoginSignupService
  ) {
    this.reloadPage = this.localStorageService.getItem('reloadPage');
    this.user = this.loginSignupService.getUserSession();
    this.localStorageService.setItem('reloadPage', 'false');
    if (this.reloadPage === 'true') {
      window.location.reload();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // console.log("on change me aya");
    if (this.cart?.microProduct) {
      this.totalAmountOfItems = 0;
      this.cart?.items?.forEach((element) => {
        this.totalAmountOfItems = element.price + this.totalAmountOfItems;
      });
    }else if(this.cart?.plan == undefined){
      this.totalAmountOfItems = 0;
      this.cart?.items?.forEach((element) => {
        this.totalAmountOfItems = element?.price + this.totalAmountOfItems;
      });
    }
  }

  ngOnInit(): void {
    this.emailId = this.loginSignupService.getUserSession()?.user?.email;
    // console.log(this.cart)
  }

  currentPrice() {
    this.transactionService
      .currentPrice()
      .then((data: any) => {
        this.packages = data;
      })
      .catch((err: any) => { });
  }
  rzp1;
  makePayment() {
    // TODO create Cart here with whatever details we have. then on success we will re-direct to the payment page.
    let requestData = {
      id: this.cart._id,
    };
    this.transactionService
      .createCartRazorpay(requestData)
      .then((data: any) => {
        this.router.navigate(['/payment/' + data.data._id]);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  removeCartOrder(cartId, sku) {
    this.transactionService
      .removeSkuFromCart(cartId, sku)
      .then((data) => {
        window.location.reload();
        // this.cart = {};
        this.reloadCart.emit();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  cartPlan(category) {
    let currentOption;
    let startDate = new Date();
    currentOption = {
      email: this.emailId,
      startdate: startDate,
      enddate: startDate.setDate(startDate.getDate() + 30),
      category: category,
      status: 'open',
    };
    this.transactionService.createCartPayOut(currentOption).then(
      (data: any) => {
        // window.location.reload();
        // this.cart = {};
        this.reloadCart.emit();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getSubscriptionName(plan) {
    if (plan == 'plan_advance') {
      return 'Advance Plan';
    } else if (plan == 'plan_premium') {
      return 'Premium Plan';
    }
  }

  getSubscriptionDescription(plan) {
    if (plan == 'plan_premium') {
      return 'Up to 3 users will have unlimited access to the content and data on the platform. Additionally, the users will have access to data regarding shareholding structure,financing ratios,company documents etc.';
    } else if (plan == 'plan_advance') {
      return 'Up to 2 users will have limited access to the content and data.Users will also have access to investments, acquisitions, revenue breakdowns etc.';
    }
  }
}
